//(function () {
//    'use strict';

//    angular.module("imApp").factory("custactCalcPickService", ['$ihttp', function ($ihttp) {
//        let service = {
//            getSetting: function (parms) {
//                return $ihttp.post({
//                    method: 874,
//                    parameters: parms || {}
//                });
//            },
//            listComponents: function (parms) {
//                return $ihttp.post({
//                    method: 872,
//                    parameters: parms || {}
//                });
//            },
//            scanStockSearch: function (setting) {
//                return $ihttp.post({
//                    method: 455,
//                    parameters: setting
//                });
//            }
//        };

//        return service;
//    }]);
//})();
